import React from 'react';
import { Switch, Route, Routes } from 'react-router-dom';

import { RecordingPage, PageWrapper } from 'components';
import AppPaths from 'constants/appPaths';
import { Redirect } from 'react-router';

const App = () => {
  const WrappedRecordingPage = PageWrapper(RecordingPage);
  const ErrorPage = (props) => <div>Oops. Something went wrong!</div>;
  return (
    <div>
      {/* <Switch>
        <Route
          path={AppPaths.RECORDING}
          component={PageWrapper(RecordingPage)}
          exact
        />
        <Route component={(props) => <div>Oops. Something went wrong!</div>} />
      </Switch> */}
      <Routes>
        <Route path={AppPaths.RECORDING} element={<WrappedRecordingPage />} />
        <Route element={<ErrorPage />} />
      </Routes>
    </div>
  );
};

export default App;
